import { useTranslation, t } from '../../i18n';
import React from 'react';
import { Table } from 'antd';

// Worker 运行限制:直接展示 API 返回的 limits(后端 WorkerLimits::effective,与边缘下发同源)。
// limits = { js:{cpu_ms,memory_mb,max_subrequests,fetch_budget_ms,max_output_mb,stack_kb}, wasm:{...}, node_concurrency, code_max_mb }
const fmtMs = (ms) => (ms == null ? '—' : ms >= 1000 ? t('{{value}} seconds', { value: ms / 1000 }) : t('{{ms}} ms', { ms: ms }));
const val = (v, unit) => (v == null ? '—' : `${v} ${unit}`);

const ROWS = [
  { key: 'cpu', label: '单次执行时间', get: (l) => fmtMs(l.cpu_ms) },
  { key: 'mem', label: '内存', get: (l) => val(l.memory_mb, 'MB') },
  { key: 'sub', label: '子请求 (fetch)', get: (l) => val(l.max_subrequests, t('Requests/execution')) },
  { key: 'budget', label: '子请求总耗时', get: (l) => fmtMs(l.fetch_budget_ms) },
  { key: 'out', label: '响应大小', get: (l) => val(l.max_output_mb, 'MB') },
  { key: 'stack', label: '栈', get: (l) => val(l.stack_kb, 'KB') },
];

const WorkerLimitsTable = ({ limits }) => {
  const { t } = useTranslation();
  if (!limits || !limits.js) return null;
  const js = limits.js || {};
  const wasm = limits.wasm || {};
  const data = ROWS.map((r) => ({ key: r.key, label: t(r.label), js: r.get(js), wasm: r.get(wasm) }));
  if (limits.code_max_mb != null) data.push({ key: 'code', label: t('Code size'), js: `${limits.code_max_mb} MB`, wasm: `${limits.code_max_mb} MB` });
  if (limits.node_concurrency != null) data.push({ key: 'conc', label: t('Node concurrency'), js: `${limits.node_concurrency}`, wasm: `${limits.node_concurrency}` });
  return (
    <Table
      size="small"
      pagination={false}
      dataSource={data}
      columns={[
        { title: '', dataIndex: 'label', width: 140 },
        { title: 'JavaScript', dataIndex: 'js' },
        { title: 'WASM', dataIndex: 'wasm' },
      ]}
    />
  );
};

export default WorkerLimitsTable;
